<!-- 学员报名信息查询 -->
<template>
    <div class="page-form">
        <PageBack :title="title" />
        <div class="detail-wrap">
            <div class="size20 center bold">{{ trainTitle }}</div>
            <el-tabs  v-model="activeName" @tab-click="changeTabs"  type="card">
                <el-tab-pane :label="item.city" :name="item.serial"
                    v-for="item in dataList" :key="item.serial">                   
                </el-tab-pane>
            </el-tabs> 
            <el-button  @click="handleExport" type="success" size="medium">导出</el-button>    
            <el-table :data="tableData" class="custom-table" style="width: 100%" border>
                <el-table-column type="index" width="50" label="序号" align="center"/>
                <el-table-column prop="username" width="80" label="学员姓名" align="center"/>       
                <el-table-column prop="phone" label="手机号" align="center"/>   
                <el-table-column prop="identity" label="身份证号" align="center" width="170"/> 
                <el-table-column prop="clothingSize" label="衣服尺码" align="center"/>
                <el-table-column prop="imageUrl" label="两寸照片" align="center">
                    <template slot-scope="scope" >
                        <span v-if="scope.row.imageUrl===''">暂无</span>
                        <el-image style="height: 50px;" :src="scope.row.imageUrl" :preview-src-list="scope.row.srcList" v-else></el-image>
                    </template>
                </el-table-column> 
                <el-table-column prop="province" label="注册省" align="center"/> 
                <el-table-column prop="city" label="注册市" align="center"/> 
                <el-table-column prop="date" label="报名日期时间" align="center" width="160"/> 
            </el-table>    
            <pagination
                style="text-align:right"
                v-show="total > 10"
                :total="total"
                :page.sync="queryParams.page"
                :limit.sync="queryParams.pagesize"
                @pagination="getUserInfo"
            />      
        </div>
    </div>
</template>
<script>
import PageBack from '@/components/PageHeader'
import pagination  from '@/components/Pagination'
export default {
    components:{
        PageBack,
        pagination,
    },
    data(){
        return{
            activeName: '1',
            publishId: '',
            tableData: [],
            dataList: [],
            queryParams: {
                page: 1,
                pagesize: 10
            },
            total: 0,
            trainTitle: '',
            exportData: []
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        },  
    },
    created(){
        this.publishId = this.$route.query.id
    },
    mounted(){
        if(this.publishId){
            this.trainDetailData()
        }
    },
    methods:{
        // 培训详情查询 1054
        trainDetailData(){
            let params = {
                opcode: this.$code.TrainDetailQuery,
                i_serial_train: this.publishId,
                id: '',
                c_status: '',
                start_date: '',
                end_date: '',
                v_economize: '',
                v_city: '',
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.total = res.Data.SumCount
                    if(result.length > 0){
                        let list = result.map(item=>{
                            return{
                                serial: item['序号'].toString(),
                                city: item['市'],
                                title: item['培训标题']
                            }
                        })    
                        this.trainTitle = list[0].title                
                        this.dataList = list
                        this.trainId = list[0].serial
                        if(this.trainId){
                            this.getUserInfo()
                        }
                    }          
                }else{
                    this.dataList = []
                }
            })
        },
        // 获取学员报名信息 1061
        getUserInfo(){
            let params = {
                opcode: this.$code.TrainUserQuery,
                i_serial_train: this.publishId,
                id: this.trainId,
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page,
            }
            this.loading = true
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {                    
                    let result = res.Data.DataTable
                    if(result.length > 0){
                        this.tableData = result.map(item=>{   
                            let dateStr = item['报名日期'] !== null ? this.$help.formatDate(item['报名日期']): ''      
                            let timeStr = item['报名时间'] !== null ?  this.$help.formatTime(item['报名时间']) : ''   
                            let imageUrl = item['两寸彩色照片'] ?  item['两寸彩色照片']: ''  
                            return{
                                index: item['序号'],
                                serial: item['培训标识'],
                                username: item['学员名称'],
                                userId:item['学员账号'],
                                phone: item['手机号'],
                                title: item['培训主题'],
                                identity: item['身份证号码'],
                                imageUrl: imageUrl,
                                srcList:[imageUrl],
                                date: dateStr + ' ' + timeStr,
                                province: item['注册省'],
                                clothingSize: item['其他'],
                                city: item['注册市'],
                            }
                        })                        
                    }else{
                        this.tableData = []
                    }    
                    this.loading = false
                    this.total = res.Data.SumCount
                }else{
                    this.loading = false
                    this.tableData = []
                }
            })
        },
        changeTabs(tab){
            this.trainId = tab.name
            if(this.trainId){
                this.getUserInfo()
            }
        },
        getExportQuery(){
            let params ={
                opcode: this.$code.TrainUserQuery,
                i_serial_train: this.publishId,
                id: this.trainId,
                pagesize: '',
                page:  '',
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                    if(result.length > 0 ){   
                        let arr = result.map(item=>{    
                            let dateStr = item['报名日期'] !== null ? this.$help.formatDate(item['报名日期']): ''      
                            let timeStr = item['报名时间'] !== null ?  this.$help.formatTime(item['报名时间']) : ''                  
                            return{
                                '学员姓名':  item['学员名称'],
                                '手机号': item['手机号'],
                                '身份证号码': item['身份证号码'],
                                '报名日期': dateStr,
                                '报名时间': timeStr,
                                '衣服尺码': item['其他']
                            }
                        })   
                        this.exportData = arr          
                    }               
                }else{
                    this.exportData= []
                    this.$message.error('暂无数据')
                }
            })
        },
        handleExport(){
            this.getExportQuery()
            setTimeout(()=>{
                if(this.exportData.length > 0 ){
                    this.$help.ExportFormData(this.exportData,'学员报名信息表')
                }else{
                    this.$message.error('暂无数据')
                }                
            },500)
        },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.container {
    background-color: #fff;
}

.detail-wrap {
    font-size: 16px;
    line-height: 28px;

}
</style>


// WEBPACK FOOTER //
// src/views/training/trainApplyQuery.vue